import type { WithSlotProps } from '~/components/hocs';
import { withSlot } from '~/components/hocs';
import { componentRegistry } from '~/components/layout/utils';

export const NAME = 'Animated';

export interface Props extends React.PropsWithChildren, WithSlotProps {
  className?: string;
  initial?: Record<string, string | number>;
  target?: Record<string, string | number>;
}

const AnimatedComponent = (props: Props) => {
  return <div className="animated">{props.children}</div>;
};

AnimatedComponent.displayName = NAME;

export const Animated = withSlot(AnimatedComponent);
componentRegistry.add(NAME, Animated);
